import React from 'react';

type SbInlineSearchProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  id?: string;
  className?: string;
};

export default function SbInlineSearch({
  value,
  onChange,
  placeholder,
  id = 'sb-inline-search',
  className = '',
}: SbInlineSearchProps) {
  return (
    <div className={`sb-inline-search mb-4 ${className}`.trim()}>
      <label className="visually-hidden" htmlFor={id}>
        {placeholder}
      </label>
      <div className="sb-inline-search__field">
        <i className="fas fa-search sb-inline-search__icon" aria-hidden />
        <input
          id={id}
          type="search"
          className="form-control sb-inline-search__input"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  );
}
